import { useCallback, useEffect, useState } from "react";
import {
  RevenueAdminData,
  RevenueFilters,
  fetchRevenueAdminData,
  initialRevenueFilters
} from "../services/revenueAdminService";

export function useRevenueAdmin() {
  const [filters, setFilters] = useState<RevenueFilters>(initialRevenueFilters);
  const [data, setData] = useState<RevenueAdminData | null>(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const refresh = useCallback(async (nextFilters = filters) => {
    setIsLoading(true);
    setError("");

    try {
      setData(await fetchRevenueAdminData(nextFilters));
    } catch {
      setData(null);
      setError("Unable to load revenue. Check Firebase permissions and indexes.");
    } finally {
      setIsLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    void refresh(initialRevenueFilters);
  }, []);

  return {
    data,
    error,
    filters,
    isLoading,
    refresh,
    setFilters
  };
}
